<template>
    <div  v-if="!successfulRegistration" class="user-registration">
      <h2>Register New User</h2>
      <form @submit.prevent="registerUser" class="form">
        <!-- Name -->
        <!-- <div class="form-group">
          <label for="name">Name:</label>
          <input v-model="name" id="name" placeholder="Enter your name" required />
        </div> -->
  
        <!-- Age -->
        <div class="form-group">
          <label for="age">Age:</label>
          <input v-model="age" type="number" id="age" placeholder="Enter your age" required />
        </div>
  
        <!-- Gender -->
        <div class="form-group">
          <label for="gender">Gender:</label>
          <select v-model="gender" id="gender" required>
            <option disabled value="">Select Gender</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
        </div>
  
        <!-- Cultural Heritage Familiarity -->
        <div class="form-group">
          <label for="heritageFamiliarity">Cultural Heritage Familiarity:</label>
          <select v-model="heritageFamiliarity" id="heritageFamiliarity" required>
            <option disabled value="">Select Frequency</option>
            <option>Rarely</option>
            <option>Occasionally</option>
            <option>Frequently</option>
          </select>
        </div>
  
        <!-- Preferred Cultural Experiences -->
        <div class="form-group">
          <label for="preferredExperiences">Preferred Cultural Experiences:</label>
          <select v-model="preferredExperiences" id="preferredExperiences" multiple required>
            <option>History</option>
            <option>Art</option>
            <option>Music</option>
            <option>Folklore</option>
            <option>Architecture</option>
            <option>Other</option>
          </select>
        </div>
  
        <!-- Participation in Cultural Activities -->
        <div class="form-group">
          <label for="culturalParticipation">Participation in Cultural Activities:</label>
          <select v-model="culturalParticipation" id="culturalParticipation" required>
            <option disabled value="">Have you participated?</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </div>
  
        <!-- Preferred Learning Style -->
        <div class="form-group">
          <label for="learningStyle">Preferred Learning Style:</label>
          <select v-model="learningStyle" id="learningStyle" required>
            <option disabled value="">Select Style</option>
            <option>Reading</option>
            <option>Watching videos</option>
            <option>Listening to guides</option>
            <option>Interactive experiences (e.g., VR, AR)</option>
            <option>Hands-on activities</option>
          </select>
        </div>
  
        <!-- Challenges in Accessing Cultural Experiences -->
        <div class="form-group">
          <label for="challenges">Challenges in Accessing Cultural Experiences:</label>
          <select v-model="challenges" id="challenges" multiple>
            <option>Physical accessibility</option>
            <option>Lack of transportation</option>
            <option>Difficulty understanding digital tools</option>
            <option>Cost</option>
            <option>Other</option>
          </select>
        </div>
  
        <!-- Technological Familiarity -->
        <div class="form-group">
          <label for="techFamiliarity">Technological Familiarity:</label>
          <select v-model="techFamiliarity" id="techFamiliarity" required>
            <option disabled value="">Select Familiarity Level</option>
            <option>Not comfortable</option>
            <option>Somewhat comfortable</option>
            <option>Very comfortable</option>
          </select>
        </div>
  
        <!-- Devices Used -->
        <div class="form-group">
          <label for="devicesUsed">Devices Used:</label>
          <select v-model="devicesUsed" id="devicesUsed" multiple required>
            <option>Smartphone</option>
            <option>Tablet</option>
            <option>Laptop/Computer</option>
            <option>None</option>
          </select>
        </div>
  
        <!-- Health-Related Constraints -->
        <div class="form-group">
          <label for="healthConstraints">Health-Related Constraints:</label>
          <select v-model="healthConstraints" id="healthConstraints" required>
            <option disabled value="">Do you have constraints?</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </div>
  
        <div class="form-group">
          <button type="submit" class="btn">Register User</button>
        </div>
      </form>
      
    </div>
    <div v-if="successfulRegistration">
        <div class="success">
          <h3>User Registered Successfully!</h3>
          <p><strong>Assigned PIN:</strong> {{ successfulRegistration.pin }}</p>
        </div>
      </div>
  
      <div v-if="errorMessage" class="error">
        <p>{{ errorMessage }}</p>
      </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // name: '',
        age: '',
        gender: '',
        heritageFamiliarity: '',
        preferredExperiences: [],
        culturalParticipation: '',
        learningStyle: '',
        challenges: [],
        techFamiliarity: '',
        devicesUsed: [],
        healthConstraints: '',
        registeredUser: null,
        errorMessage: null,
        successfulRegistration: null,
      };
    },
    methods: {
      async registerUser() {
        this.registeredUser = null;
        this.errorMessage = null;
  
        const pin = Math.floor(1000 + Math.random() * 9000);
  
        try {
          const response = await fetch('https://firefly-setup.athenarc.gr/register-user', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
            //   name: this.name,
              age: this.age,
              gender: this.gender,
              heritageFamiliarity: this.heritageFamiliarity,
              preferredExperiences: this.preferredExperiences,
              culturalParticipation: this.culturalParticipation,
              learningStyle: this.learningStyle,
              challenges: this.challenges,
              techFamiliarity: this.techFamiliarity,
              devicesUsed: this.devicesUsed,
              healthConstraints: this.healthConstraints,
              pin,
            }),
          });
  
          if (!response.ok) {
            throw new Error('Failed to register user');
          }
  
          this.successfulRegistration = await response.json();
          this.resetForm();
        } catch (error) {
          this.errorMessage = `An error occurred: ${error.message}`;
        }
      },
      resetForm() {
        // this.name = '';
        this.age = '';
        this.gender = '';
        this.heritageFamiliarity = '';
        this.preferredExperiences = [];
        this.culturalParticipation = '';
        this.learningStyle = '';
        this.challenges = [];
        this.techFamiliarity = '';
        this.devicesUsed = [];
        this.healthConstraints = '';
      },
    },
  };
  </script>
  
  <style scoped>
  .user-registration {
    max-width: 600px;
    margin: 2rem auto;
    padding: 1.5rem;
    border-radius: 10px;
    background-color: #f9f9f9;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    font-family: Arial, sans-serif;
  }
  
  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1.2rem;
  }
  
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  
  input,
  select {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  input:focus,
  select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  
  .btn {
    width: 100%;
    padding: 0.8rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .btn:hover {
    background-color: #0056b3;
  }
  
  .success {
    background-color: #d4edda;
    padding: 1rem;
    border-radius: 5px;
    border: 1px solid #c3e6cb;
    margin-top: 1rem;
  }
  
  .error {
    background-color: #f8d7da;
    padding: 1rem;
    border-radius: 5px;
    border: 1px solid #f5c6cb;
    margin-top: 1rem;
  }
  </style>
  